import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { memoriesApi } from "../../app-api/memories";
import MemoryEditor from "../../components/MemoryEditor";

const MemoryEditorPage = () => {
  const { memoryID } = useParams();
  const location = useLocation();

  const [initialMemory, setInitialMemory] = useState(
    location.state?.memory ?? null,
  );
  const [isLoading, setIsLoading] = useState(
    !!memoryID && !location.state?.memory,
  );
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!(memoryID || location.state?.memory)) return;

    setIsLoading(true);
    memoriesApi
      .getMemoryById(memoryID)
      .then((res) => {
        setInitialMemory(res?.data?.[0] ?? res?.data ?? null);
      })
      .catch(() => setError("Failed to load memory."))
      .finally(() => setIsLoading(false));
  }, [memoryID, location.state?.memory]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontFamily: "Inter, sans-serif",
          fontSize: 17,
          color: "#4c5367",
        }}
      >
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontFamily: "Inter, sans-serif",
          fontSize: 17,
          color: "#991932",
        }}
      >
        {error}
      </div>
    );
  }

  return (
    <MemoryEditor memoryID={memoryID ?? null} initialMemory={initialMemory} />
  );
};

export default MemoryEditorPage;
